import React from "react";
import { useSelector } from "react-redux";
import EmptyData from "../EmptyData/EmptyData";
import Colors from "../../Constants/Colors";

const CustomAttendRenderScreen = ({
  checkingDetails,
  handelEventMedia,
  onClickCheckInEvent,
}) => {
  const isLoading = useSelector((state) => state.isLoading);
  return (
    <div className="scrollable-container h-max-350">
      {!isLoading && checkingDetails.length == 0 ? (
        <EmptyData />
      ) : (
        checkingDetails?.map((item, index) => (
          <div key={index}>
            <div className="achievement-stretch-row">
              <div className="lastWeekEndDivGreyColor w-10">
                <img className="subcategory-input" src={item.eventImages} />
              </div>
              <div className="fontSize16WithoutFlex w-20">{item.eventName}</div>
              <div style={{}} className="fontSize16WithoutFlex w-40">
                {item.venueAddress}
              </div>
              <div className="fontSize16WithoutFlex w-20">
                {item.eventStartDate}
              </div>

              <div className="user_Status user_name pointer w-10">
                <button
                  onClick={() => onClickCheckInEvent(item)}
                  className="button"
                  disabled={item?.isCheckIn}
                  style={{
                    cursor: item?.isCheckIn ? "auto" : "pointer",
                    color: item?.isCheckIn
                      ? Colors.mainGreen
                      : Colors.mainOrange,
                  }}
                >
                  {item?.isCheckIn ? "Attend" : "Check-In"}
                </button>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};
export default CustomAttendRenderScreen;
